import React from 'react';
import cn from 'classnames';
import Carousel, {
	ICarouselProps,
	CarouselItem,
} from 'tbk-components/src/components/Carousel';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ISimpleGalleryProps extends ICarouselProps {
	images?: IImage[];
}

/**
 * Simple Gallery
 * @block
 * @requiresHooks
 */
const SimpleGallery: React.FC<ISimpleGalleryProps> = ({
	className,
	images = [],
}) => (
	<Carousel className={className || cn('simple-gallery')}>
		{images.map((image, i) => (
			<CarouselItem key={i}>
				<Image {...image} />
			</CarouselItem>
		))}
	</Carousel>
);

export default SimpleGallery;
